"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SvgDoNotTranslate = function SvgDoNotTranslate(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], props, /*#__PURE__*/_react["default"].createElement("style", null, '.do_not_translate_svg__st2,.do_not_translate_svg__st3{fill:none;stroke:#6fcbdc;stroke-width:2.834646e-02;stroke-miterlimit:10}.do_not_translate_svg__st3{stroke:#e4097c;stroke-width:1.417323e-02}.do_not_translate_svg__st5{fill:#333}'), /*#__PURE__*/_react["default"].createElement("g", {
    id: "do_not_translate_svg__icon"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.3 2L2 3.3 20.7 22l1.3-1.3L3.3 2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.7 16.5h-2.3l.6-1.7-1.2-1.2-2.7 7.4h1.8l1-2.7h4.3l1 2.7 1.6-.1.1-.3-4.2-4.1zM10.4 6.6h1.7c-.1.4-.3.8-.5 1.2L12.8 9c.4-.8.7-1.6 1-2.4h2.6V4.8h-6.3V3H8.3v1.5l2.1 2.1zM15.6 11.7l1.2 1.2.1-.3.2.7 3.2 3.2-2.4-6.3h-1.8zM10.4 12.5c.6-.6 1-1.3 1.5-1.9l-1.2-1.2c-.4.7-.9 1.4-1.5 2-.8-.9-1.5-1.9-2.1-3H5.3C6 9.9 6.9 11.3 8 12.5L3.4 17l1.3 1.3 4.5-4.5 2.8 2.8.7-1.8-2.3-2.3zM6.1 4.8H2v1.8h5.9z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    id: "do_not_translate_svg__canvas"
  }));
};

var _default = SvgDoNotTranslate;
exports["default"] = _default;